export type MediaStreamId = 'microphoneTester' | 'sessionRecorder';

export interface EluveMediaStreamsRegistry {
  stop(key: MediaStreamId): void;
  stopAll(): void;
  get(key: MediaStreamId): MediaStream | null | undefined;
  set(
    key: MediaStreamId,
    value: MediaStream | null,
  ): Map<MediaStreamId, MediaStream | null>;
  clear(): void;
  delete(key: MediaStreamId): boolean;
  getTracks(key: MediaStreamId): MediaStreamTrack[];
}

export class EluveMediaStreams
  extends Map<MediaStreamId, MediaStream | null>
  implements EluveMediaStreamsRegistry
{
  stop(key: MediaStreamId) {
    this.get(key)
      ?.getTracks()
      .forEach((track) => {
        track.stop();
      });
  }

  stopAll() {
    this.forEach((mediaStream) => {
      mediaStream?.getTracks().forEach((track) => {
        track.stop();
      });
    });
  }

  override set(key: MediaStreamId, value: MediaStream | null) {
    this.stop(key);
    return super.set(key, value);
  }

  override clear(): void {
    this.stopAll();
    super.clear();
  }

  override delete(key: MediaStreamId): boolean {
    this.stop(key);
    return super.delete(key);
  }

  getTracks(key: MediaStreamId): MediaStreamTrack[] {
    return this.get(key)?.getTracks() ?? [];
  }
}

export const setupEluveMediaStreams = () => {
  window.eluveMediaStreams = new EluveMediaStreams();
};

declare global {
  interface Window {
    eluveMediaStreams: EluveMediaStreamsRegistry;
  }
}
